export default "__VITE_ASSET__61cH0$vE__"